import { render, staticRenderFns } from "./ViewProfile.vue?vue&type=template&id=eb3f2542&scoped=true&"
import script from "./ViewProfile.vue?vue&type=script&lang=ts&"
export * from "./ViewProfile.vue?vue&type=script&lang=ts&"
import style0 from "./ViewProfile.vue?vue&type=style&index=0&id=eb3f2542&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3f2542",
  null
  
)

export default component.exports